import { useEffect } from "react";
import styles from "./TablesAndFiguresModal.module.scss";
import { useOpenInModal } from "../../hooks/OpenInModalHooks/useOpenInModal";
import useMobileOrientation from "../../hooks/useMobileOrientation";
import PropTypes from "prop-types";

const TablesAndFiguresModal = ({ title, sectionId }) => {
  const openInModal = useOpenInModal();
  const mobileOrientation = useMobileOrientation();
  useEffect(() => {
    if (openInModal.showBanner) {
      setTimeout(() => {
        openInModal.closeBanner();
      }, 5000);
    }
  }, [openInModal.showBanner]);

  if (!openInModal.isOpen) return null;

  return (
    <div
      className={styles.modalDialog}
      onClick={(e) => e.stopPropagation()}
      aria-label="Tables And Figures Modal"
    >
      <div className={styles.modalHeader}>
        <button
          type="button"
          aria-label="Close Tables and Figures Modal"
          className={`${styles.closeButton}`}
          onClick={openInModal.closeModal}
        >
          <i className="tg-icons-Cross"></i>
        </button>
        <h3 className={styles.title}>{title}</h3>
      </div>
      {mobileOrientation.isPortrait && openInModal.showBanner && (
        <div className={styles.banner}>
          <i className={`tg-icons-MobileOrientation ${styles.orientationIcon}`}></i>
          <span className={styles.bannerText}>View in landscape mode for the best experience</span>
          <button
            type="button"
            aria-label="Close Mobile Orientation Banner"
            className={`${styles.closeButton}`}
            onClick={openInModal.closeBanner}
          >
            <i className="tg-icons-Cross"></i>
          </button>
        </div>
      )}
      {openInModal.modalContent ? (
        <div
          id="contentId"
          className={`${styles.modalContent} appMode maincontent`}
          dangerouslySetInnerHTML={{ __html: openInModal.modalContent }}
        />
      ) : (
        <div>No content to display</div>
      )}
    </div>
  );
};

TablesAndFiguresModal.propTypes = {
  title: PropTypes.string.isRequired,
  sectionId: PropTypes.string,
};

export default TablesAndFiguresModal;
